import { faker } from '@faker-js/faker';
import { generateInitialPaginationApi } from '@ingenico/api-sdk-core/mocks';
import type {
  GetKeySetReferenceV2QueryResponseApi,
  KeySetReferenceResourceReadApi,
} from '@ingenico/api-sdk-device-management-private-v2';

function getKeySetReferenceResourceReadApi(): KeySetReferenceResourceReadApi {
  return {
    keySet: faker.commerce.productName(),
    environment: faker.commerce.department(),
    domain: faker.commerce.department(),
    keySetType: 'KEY_TYPE_AES',
  };
}

export function getKeySetReferenceV2ResponseMock(): GetKeySetReferenceV2QueryResponseApi {
  const count = faker.number.int({ min: 5, max: 20 });

  return {
    data: faker.helpers.multiple(getKeySetReferenceResourceReadApi, { count }),
    pagination: generateInitialPaginationApi(count),
  };
}
